import Notfound from "./Notfound";
import ServerError from "./ServerError";

export default Notfound;
export { ServerError };
